namespace GeniuzPOS.SalePromoCamp {
    export interface LookupItemCodeRow {
        ItemId?: string;
        ItemType?: number;
        ItemCode?: string;
        ItemDesc?: string;
        IDName?: string;
    }

    export namespace LookupItemCodeRow {
        export const idProperty = 'ItemId';
        export const nameProperty = 'IDName';
        export const localTextPrefix = 'SalePromoCamp.LookupItemCode';
        export const lookupKey = 'SalePromoCamp.LookupItemCode';

        export function getLookup(): Q.Lookup<LookupItemCodeRow> {
            return Q.getLookup<LookupItemCodeRow>('SalePromoCamp.LookupItemCode');
        }
        export const deletePermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:Modify';
        export const insertPermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:Modify';
        export const readPermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:View';
        export const updatePermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:Modify';

        export declare const enum Fields {
            ItemId = "ItemId",
            ItemType = "ItemType",
            ItemCode = "ItemCode",
            ItemDesc = "ItemDesc",
            IDName = "IDName"
        }
    }
}
